<!--The content below is only a placeholder and can be replaced.-->
<section class="page-section section-auth" #loginPageElm>

    <auth-header [logoSize]="'logo-large'"></auth-header>

    <div class="ui-view-main">

        <div class="container">
            <div class="row">
                <div class="col-8 col-offset-2">
                    <h1 class="align-center" [innerHTML]="'auth.headers.login' | translate"></h1>

                   <p *ngIf="loginIntroTxtEnabled" class="intro align-center" [innerHTML]="'auth.labels.login_intro' | translate"></p>
                </div>
            </div>

            <div *ngIf="!showActivationCodeInput" class="row auth-split">
                <div *ngIf="hasFormLogin()" class="col-4 col-offset-1 user-player">
                    <login-form></login-form>
                </div>

                <div *ngIf="true" class="col-4 col-offset-7">
                    <div class="sso-block">
                        <ng-container *ngFor="let authMethod of allowedAuthMethods">
                            <a
                                    *ngIf="authMethod.method !== 'form' else formButton"
                                    class="btn-sso"
                                    [href]="getHrefForAuthMethod(authMethod)"
                                    [ngClass]="authMethod.class_name"
                            >
                                <ng-container *ngIf="authMethod.image">
                                    <div>
                                        <img alt="auth-method-image" [src]="authMethod.image"/>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="!authMethod.image">
                                    <div class="icon"></div>
                                </ng-container>
                                <span [innerHTML]="authMethod.button_text | translate"></span>
                            </a>
                            <ng-template #formButton>
                                <a
                                        class="btn-sso"
                                        (click)="toggleActivationCodeForm()"
                                        [ngClass]="authMethod.class_name"
                                >
                                    <div class="icon"></div>

                                    <span [innerHTML]="authMethod.button_text | translate"></span>
                                </a>
                            </ng-template>
                        </ng-container>
                    </div>
                </div>

            </div>

            <div *ngIf="showActivationCodeInput" class="row auth-split">
                <activation-code (canceled)="toggleActivationCodeForm()"></activation-code>
            </div>

            <div *ngIf="theme === 'athand'" class="row row-logos">
                <div class="col-12">
                    <div class="theme-logos-block">
                        <div class="logo-tile heroes"></div>
                        <div class="logo-tile champs"></div>
                        <div class="logo-tile investigators"></div>
                        <div class="logo-tile globetrotters"></div>
                        <div class="logo-tile superstars"></div>
                        <div class="logo-tile hub"></div>
                    </div>
                </div>
            </div>
            <div *ngIf="theme != 'athand'" class="row row-steps">
                <div class="col-4">
                    <h4 [innerHTML]="'auth.labels.title_bottom1' | translate">
                        Create your Hero
                    </h4>
                    <div class="stepinfo"></div>
                </div>
                <div class="col-4 col-offset-4">
                    <h4 [innerHTML]="'auth.labels.title_bottom2' | translate">
                        Beat the villain...
                    </h4>
                    <div class="stepinfo"></div>
                </div>
                <div class="col-4 col-offset-8">
                    <h4 [innerHTML]="'auth.labels.title_bottom3' | translate">
                        Save the world
                    </h4>
                    <div class="stepinfo"></div>
                </div>
            </div>

        </div>

    </div>

</section>
